import React from 'react';
import Card from '../../ui/Card';
import { TrendingUpIcon, TrendingDownIcon, MinusIcon } from 'lucide-react';
const CompetitorComparisonTable: React.FC = () => {
  const competitorData = [{
    company: 'Our Company',
    marketShare: 12.8,
    trend: 'up',
    revenue: 9250,
    productRange: 485,
    priceIndex: 92,
    qualityScore: 88,
    innovationScore: 85,
    reliabilityScore: 92,
    customerSat: 8.2,
    dealerNetwork: 534,
    rndSpend: 3.8,
    isUs: true
  }, {
    company: 'Competitor A (Market Leader)',
    marketShare: 18.5,
    trend: 'stable',
    revenue: 13500,
    productRange: 620,
    priceIndex: 78,
    qualityScore: 82,
    innovationScore: 70,
    reliabilityScore: 88,
    customerSat: 7.8,
    dealerNetwork: 785,
    rndSpend: 2.9,
    isUs: false
  }, {
    company: 'Competitor B',
    marketShare: 15.2,
    trend: 'up',
    revenue: 11200,
    productRange: 558,
    priceIndex: 95,
    qualityScore: 92,
    innovationScore: 88,
    reliabilityScore: 85,
    customerSat: 8.5,
    dealerNetwork: 642,
    rndSpend: 4.2,
    isUs: false
  }, {
    company: 'Competitor C',
    marketShare: 13.8,
    trend: 'up',
    revenue: 10100,
    productRange: 512,
    priceIndex: 98,
    qualityScore: 95,
    innovationScore: 92,
    reliabilityScore: 90,
    customerSat: 8.7,
    dealerNetwork: 598,
    rndSpend: 4.5,
    isUs: false
  }, {
    company: 'Competitor D',
    marketShare: 11.2,
    trend: 'stable',
    revenue: 8200,
    productRange: 445,
    priceIndex: 88,
    qualityScore: 85,
    innovationScore: 78,
    reliabilityScore: 86,
    customerSat: 7.9,
    dealerNetwork: 485,
    rndSpend: 3.2,
    isUs: false
  }, {
    company: 'Competitor E',
    marketShare: 9.8,
    trend: 'down',
    revenue: 7200,
    productRange: 398,
    priceIndex: 85,
    qualityScore: 78,
    innovationScore: 72,
    reliabilityScore: 80,
    customerSat: 7.5,
    dealerNetwork: 425,
    rndSpend: 2.8,
    isUs: false
  }, {
    company: 'Competitor F',
    marketShare: 7.5,
    trend: 'down',
    revenue: 5500,
    productRange: 325,
    priceIndex: 72,
    qualityScore: 75,
    innovationScore: 68,
    reliabilityScore: 78,
    customerSat: 7.2,
    dealerNetwork: 358,
    rndSpend: 2.5,
    isUs: false
  }];
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return <TrendingUpIcon size={16} className="text-green-600" data-id="element-6933" />;
    if (trend === 'down') return <TrendingDownIcon size={16} className="text-red-600" data-id="element-6934" />;
    return <MinusIcon size={16} className="text-gray-400" data-id="element-6935" />;
  };
  const getScoreColor = (score: number, threshold: number) => {
    if (score >= threshold + 5) return 'text-green-600 font-bold';
    if (score >= threshold) return 'text-gray-900 font-semibold';
    if (score >= threshold - 5) return 'text-yellow-600';
    return 'text-red-600';
  };
  const getRankBadge = (rank: number) => {
    if (rank === 1) return 'bg-gradient-to-r from-yellow-400 to-yellow-600 text-white';
    if (rank === 2) return 'bg-gradient-to-r from-gray-300 to-gray-400 text-white';
    if (rank === 3) return 'bg-gradient-to-r from-orange-400 to-orange-600 text-white';
    return 'bg-gray-200 text-gray-700';
  };
  return <Card className="p-6" data-id="element-6936">
      <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-6937">
        Comprehensive Competitor Comparison
      </h3>
      <div className="overflow-x-auto" data-id="element-6938">
        <table className="w-full" data-id="element-6939">
          <thead data-id="element-6940">
            <tr className="border-b-2 border-gray-300" data-id="element-6941">
              <th className="text-left py-3 px-4 text-sm font-bold text-gray-700 sticky left-0 bg-white z-10" data-id="element-6942">
                Company
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6943">
                Market Share
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6944">
                Trend
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6945">
                Revenue
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6946">
                Product Range
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6947">
                Price Index
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6948">
                Quality Score
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6949">
                Innovation
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6950">
                Reliability
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6951">
                Customer Sat
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6952">
                Dealer Network
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6953">
                R&D Spend %
              </th>
            </tr>
          </thead>
          <tbody data-id="element-6954">
            {competitorData.map((row, index) => <tr key={index} className={`border-b border-gray-100 hover:bg-gray-50 ${row.isUs ? 'bg-blue-50' : ''}`} data-id="element-6955">
                <td className={`py-3 px-4 text-sm font-semibold sticky left-0 z-10 ${row.isUs ? 'text-blue-700 bg-blue-50' : 'text-gray-800 bg-white'}`} data-id="element-6956">
                  <div className="flex items-center" data-id="element-6957">
                    {index < 3 && <span className={`inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold mr-2 ${getRankBadge(index + 1)}`} data-id="element-6958">
                        {index + 1}
                      </span>}
                    {row.company}
                    {row.isUs && <span className="ml-2 text-xs bg-blue-600 text-white px-2 py-0.5 rounded-full" data-id="element-6959">
                        Us
                      </span>}
                  </div>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-6960">
                  <span className={`text-sm font-bold ${row.isUs ? 'text-blue-600' : 'text-gray-900'}`} data-id="element-6961">
                    {row.marketShare}%
                  </span>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-6962">
                  {getTrendIcon(row.trend)}
                </td>
                <td className="py-3 px-4 text-sm text-right font-medium text-gray-800" data-id="element-6963">
                  ₹{row.revenue} Cr
                </td>
                <td className="py-3 px-4 text-sm text-center text-gray-700" data-id="element-6964">
                  {row.productRange}
                </td>
                <td className="py-3 px-4 text-center" data-id="element-6965">
                  <span className={`text-sm ${getScoreColor(row.priceIndex, 85)}`} data-id="element-6966">
                    {row.priceIndex}
                  </span>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-6967">
                  <span className={`text-sm ${getScoreColor(row.qualityScore, 85)}`} data-id="element-6968">
                    {row.qualityScore}
                  </span>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-6969">
                  <span className={`text-sm ${getScoreColor(row.innovationScore, 80)}`} data-id="element-6970">
                    {row.innovationScore}
                  </span>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-6971">
                  <span className={`text-sm ${getScoreColor(row.reliabilityScore, 85)}`} data-id="element-6972">
                    {row.reliabilityScore}
                  </span>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-6973">
                  <span className={`text-sm ${getScoreColor(row.customerSat * 10, 80)}`} data-id="element-6974">
                    {row.customerSat}/10
                  </span>
                </td>
                <td className="py-3 px-4 text-sm text-center text-gray-700" data-id="element-6975">
                  {row.dealerNetwork}
                </td>
                <td className="py-3 px-4 text-center" data-id="element-6976">
                  <span className={`text-sm ${getScoreColor(row.rndSpend * 10, 35)}`} data-id="element-6977">
                    {row.rndSpend}%
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-6978">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-6979">
          <div className="text-center" data-id="element-6980">
            <div className="text-xs text-gray-600 mb-1" data-id="element-6981">Our Rank</div>
            <div className="text-2xl font-bold text-blue-600" data-id="element-6982">#3</div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-6983">in market share</div>
          </div>
          <div className="text-center" data-id="element-6984">
            <div className="text-xs text-gray-600 mb-1" data-id="element-6985">Gap to Leader</div>
            <div className="text-2xl font-bold text-orange-600" data-id="element-6986">5.7%</div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-6987">
              market share points
            </div>
          </div>
          <div className="text-center" data-id="element-6988">
            <div className="text-xs text-gray-600 mb-1" data-id="element-6989">
              Competitive Strength
            </div>
            <div className="text-2xl font-bold text-green-600" data-id="element-6990">Strong</div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-6991">overall position</div>
          </div>
          <div className="text-center" data-id="element-6992">
            <div className="text-xs text-gray-600 mb-1" data-id="element-6993">Key Advantage</div>
            <div className="text-2xl font-bold text-purple-600" data-id="element-6994">92</div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-6995">reliability score</div>
          </div>
        </div>
      </div>
      <div className="mt-4 p-4 bg-green-50 rounded-lg border border-green-200" data-id="element-6996">
        <div className="flex items-start" data-id="element-6997">
          <div className="flex-shrink-0 w-2 h-2 rounded-full bg-green-600 mt-1.5 mr-2" data-id="element-6998" />
          <div className="text-sm text-green-800" data-id="element-6999">
            <span className="font-semibold" data-id="element-7000">Competitive Advantage:</span>{' '}
            Leading in reliability (92) and R&D investment (3.8%), with strong
            innovation score (85). Opportunity to close market share gap through
            expanded dealer network and enhanced product range.
          </div>
        </div>
      </div>
      <div className="mt-4 grid grid-cols-3 gap-2 text-xs" data-id="element-7001">
        <div className="flex items-center" data-id="element-7002">
          <div className="w-3 h-3 rounded bg-green-500 mr-2" data-id="element-7003" />
          <span className="text-gray-600" data-id="element-7004">Above Market Average</span>
        </div>
        <div className="flex items-center" data-id="element-7005">
          <div className="w-3 h-3 rounded bg-yellow-500 mr-2" data-id="element-7006" />
          <span className="text-gray-600" data-id="element-7007">At Market Average</span>
        </div>
        <div className="flex items-center" data-id="element-7008">
          <div className="w-3 h-3 rounded bg-red-500 mr-2" data-id="element-7009" />
          <span className="text-gray-600" data-id="element-7010">Below Market Average</span>
        </div>
      </div>
    </Card>;
};
export default CompetitorComparisonTable;